import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import placeholder from '../../assets/videoImgs/thumbshot1.jpg';
import testPlaceholder from '../../assets/img/test-thumb.jpeg';
import PieChart from 'react-minimal-pie-chart';

import api from '../../utils/api';

class LectureTile extends Component {
    render(){
        let {videoClass, iconClass, lecture, chapterIndex, lectureIndex} = this.props;
        if(lecture.type === "test"){
            return (
                <span className="video-item-wrapper">
                     <div className={`swiper-slide video-item ${videoClass}`} onClick={(e) => {
                        if(videoClass !== 'video-locked'){
                            this.props.history.push(`/subject-test/${lecture.id}`);
                        }
                    }}>

                        
                            <a ><img src={testPlaceholder} alt="Video" /> </a>

                        

                        <div className="video-item-name">
                            <Link to={(videoClass !== 'video-locked') ? `/subject-test/${lecture.id}` : ``}>{lecture.name}</Link>

                            {(videoClass !== 'video-locked') ?
                                <Link
                                    to={(videoClass !== 'video-locked') ? `/subject-test/${lecture.id}` : ``}
                                    className="btn btn-danger btn-test"
                                >Begin!</Link>
                                
                                :
                                null
                            }

                        </div>



                    </div>

                    </span>
            )
        }else{
            return (
                <span className="video-item-wrapper">
                    <div className={`swiper-slide video-item ${videoClass}`} onClick={(e) => {
                        if(videoClass !== 'video-locked'){
                            this.props.history.push(`/video/item/${lecture.id}`);
                        }
                    }}>
                        
                        <Link to={(videoClass !== 'video-locked') ? `/video/item/${lecture.id}` : ``}><i className={(this.props.user.user.role !== 'admin' || videoClass !== 'admin-video') ? iconClass : ''}></i></Link>
                        

                        {lecture.ChapterPartImage ?
                        <a ><img src={api.makeFileURL(lecture.ChapterPartImage.tinyUrl ? lecture.ChapterPartImage.tinyUrl : lecture.ChapterPartImage.url, this.props.user.id)} alt="Video" /> </a>
                            :
                            lecture.VideoFile[lecture.VideoFile.length - 1].xsThumb ?
                                <img src={api.makeFileURL(lecture.VideoFile[lecture.VideoFile.length - 1].xsThumb )} alt="Video" />
                                
                            :
                            lecture.VideoFile[lecture.VideoFile.length - 1].thumbnail ?
                                <img src={api.makeFileURL(lecture.VideoFile[lecture.VideoFile.length - 1].thumbnail )} alt="Video" />
                                :
                            <img src={placeholder} alt="Video" />

                        }

                        <div className="video-item-name">
                            <Link to={(videoClass !== 'video-locked') ? `/video/item/${lecture.id}` : ``}>{lecture.title}</Link>

                            {(lecture.UserLecture.length > 0 || this.props.videoClass === 'active-video' || this.props.user.user.role === 'admin' || videoClass === 'admin-video') &&
                                <PieChart
                                    style={{width: 48, margin: '0 auto', marginTop: '32px', position: 'absolute',
                                    left: '75px',
                                    top: '25px'}}
                                    data={[
                                        {value: lecture.UserLecture.length > 0 ? lecture.UserLecture[0].duration ? lecture.UserLecture[0].duration : 100 : 100, color: '#555'},
                                        {value: lecture.UserLecture.length > 0 ? lecture.UserLecture[0].currentTime : 0, color: '#e33339'}
                                    ]}
                                    startAngle={-90}
                                    totalValue={lecture.UserLecture.length > 0 ? lecture.UserLecture[0].duration : 100}
                                    lineWidth={20}
                                    rounded={true}
                                />
                            }


                            {iconClass === 'zmdi zmdi-check-circle' || this.props.user.user.role === 'admin' || videoClass === 'admin-video' ?
                            
                                <div>
                                <div className="completed-video-icon">
                                <Link to={(videoClass !== 'video-locked') ? `/video/item/${lecture.id}` : ``}><i className={'zmdi zmdi-play'}></i></Link>
                                </div>
  
                                </div>
                                : null
                            }
                            
                        
                        </div>



                    </div>
                    {this.props.showLecturePartDetails === lectureIndex && this.props.showLectureDetails === chapterIndex &&
                        
                        <div className={"active-lecture-icon"} style={{borderBottomColor: 
                        (this.props.courseUser[0].currentChapterPart !== this.props.chapterPart.id &&
                        this.props.courseUser[0].completedChapterParts.filter(p => p.id === this.props.chapterPart.id).length === 0) ? '#dd4b39' : '#323232'}}></div>
                    }
                </span>
            )
        }
    }
}

export default LectureTile;


// WEBPACK FOOTER //
// ./src/components/Video/LectureTile.js